import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=6c75dbb6&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c75dbb6",
  null
  
)

export default component.exports